import { JSX, FC } from 'react';
import {
  LEGEND_BACKGROUND_COLOR,
  LEGEND_BOX_SHADOW_COLOR
} from '@app/overviews/market-expansion-dashboard/MarketExpansionDashboardConstants';

interface GradientLegendProps {
  legendTitle: string;
  maxColor: string;
  maxValue: number;
  minColor: string;
  minValue?: number;
  qesTestId: string;
}

const GradientLegend: FC<GradientLegendProps> = ({ maxValue, maxColor, minColor, legendTitle, qesTestId, minValue = 0 }): JSX.Element => {
  return (
    <div
      className="market-expansion-dashboard__gradient-legend"
      id={qesTestId}
      style={{
        backgroundColor: LEGEND_BACKGROUND_COLOR,
        boxShadow: `0 0.1rem 0.25rem ${LEGEND_BOX_SHADOW_COLOR}`,
      }}
    >
      <div className="gradient-legend-title">
        {legendTitle}
      </div>
      <div className="gradient-legend-body">
        <div className="gradient-column"
          style={{ background: `linear-gradient(to bottom, ${maxColor}, ${minColor})` }} />
        <div className="label-column">
          <span>{maxValue.toLocaleString()}</span>
          <span>{minValue.toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
};

export default GradientLegend;